import { CategoryMapUpdatePage } from "@/features/channel-category/pages/CategoryMapUpdatePage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/category-map/$categoryID/update")({
	component: RouteComponent,
});

function RouteComponent() {
	const { categoryID } = Route.useParams();
	return <CategoryMapUpdatePage categoryID={categoryID} />;
}
